import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { RequireFeature } from '@/features/authentication';
import { LazyLoad } from '@/shared/components/LazyLoad';

const RbacPage = lazy(() => import('./rbac/pages/RbacPage'));

/**
 * Role & Permissions.
 *
 * The path is relative: `app/routes/protectedRoutes.tsx` nests this inside the
 * Layout branch, so a leading "/" would lift it out of the shell. The page is
 * lazy for the usual reason -- it pulls PrimeReact dialogs that no other screen
 * needs.
 *
 * <h2>Guarded by the feature, not by the ADMIN role</h2>
 *
 * The sidebar entry carries `feature: 'RBAC'` and the backend guards the role,
 * feature and permission endpoints with `@perm.on('RBAC', …)`. The route sat
 * behind `requiredRoles={[ROLES.ADMIN]}` instead, so granting RBAC to another
 * role put the menu entry in that role's sidebar and refused the click. The
 * guard now asks the same question the menu and the API ask.
 */
export const rbacRoutes: RouteObject[] = [
  {
    path: 'rbac',
    element: (
      <RequireFeature feature="RBAC">
        <LazyLoad>
          <RbacPage />
        </LazyLoad>
      </RequireFeature>
    ),
  },
];
